import {createContext} from 'react';
import { filterData } from '../components/DropdownFilter';
import { cardType } from '../components/Card';
// import {filterData} from '../components/DropdownFilter';

export interface cardDataType {
   id: number,
   companyId: number,
   contactId: number,
   coverageId: number,
   facilityTypeId: number,
   notes: string,
   submissionReq: string,
   minimumCms: string,
   minimumTiv: string,
}

export interface cardDataContextType {
    data: cardType[],
    carrier: filterData[],
    contact: filterData[]
}

const CardContext = createContext<cardDataContextType>({
    data: [],
    carrier: [],
    contact: []
});

export {CardContext};

